import BiddingField from './styled';

export default BiddingField;
